<template>
  <v-card class="mx-auto text-center mt-2 mb-2" color="white" flat>
    <v-list-item class="pa-0">
      <v-list-item-content>
        <v-row class="row-header-dougnut" justify="center">
          <v-col cols="4" class="col2 text-center">{{ getRowHeader(0) }}</v-col>
          <v-col cols="4" class="col2 text-center">{{ getRowHeader(1) }}</v-col>
          <v-col cols="4" class="text-center">{{ getRowHeader(2) }}</v-col>
        </v-row>
        <v-row class="row-data" justify="center">
          <v-col cols="4" class="col1">{{ incometax("monthly")}}</v-col>
          <v-col cols="4" class="col1">{{ natInsurance("monthly")}}</v-col>
          <v-col cols="4" class>{{ takehome("monthly")}}</v-col>
        </v-row>
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <canvas ref="myChart" width="100" height="30"></canvas>
    </v-card-text>
  </v-card>
</template>

<script>
import Chart from "chart.js";

export default {
  watch: {
    "$store.state.takeHome": function() {
      if (_currChart == null) return;
      _currChart.data.labels = this.getLabels();
      _currChart.data.datasets[0].data = this.getValues();
      _currChart.update(0);
    }
  },
  methods: {
    getRowHeader(rowID) {
      if (rowID == 0) return this.onMobile ? "Inc Tax" : "Income Tax";
      if (rowID == 1) return this.onMobile ? "Nat Ins" : "National Insurance";
      if (rowID == 2) return this.onMobile ? "Takehome" : "Take Home";
    },
    incometax(period) {
      return this.$store.getters.getIncomeTax(period);
    },
    natInsurance(period) {
      return this.$store.getters.getNationalInsurance(period);
    },
    takehome(period) {
      return this.$store.getters.getTakeHome(period);
    },
    getLabels() {
      // get the current data range (we don't really care how and which one - it's
      // the ratio's that are of interest to us
      let data = this.$store.getters.getChartData;

      let incomeTax = data[3]; // total income tax (just income tax NOT NI contrib.)
      let natInusrance = data[4];
      let takeHome = data[5];
      let total = data[0]; // incomeTax + natInusrance + takeHome;

      let xx = (txt, x) => txt + " (" + ((x / total) * 100).toFixed(1) + "%)";

      let percIT = xx(this.getRowHeader(0), incomeTax);
      let percNI = xx(this.getRowHeader(1), natInusrance);
      let percTH = xx(this.getRowHeader(2), takeHome);

      return [percIT, percNI, percTH];
    },
    getValues() {
      // get the current data range (we don't really care how and which one - it's
      // the ratio's that are of interest to us
      let data = this.$store.getters.getChartData;

      let incomeTax = data[2];
      let natInusrance = data[4];
      let takeHome = data[5];

      return [incomeTax, natInusrance, takeHome];
    }
  },
  computed: {
    onMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  },
  mounted() {
    let el = this.$refs.myChart;

    let options = {
      legend: {
        position: "right" // this.onMobile ? "right" : "top"
      }
    };

    doCreateChart(el, options, this.getLabels, this.getValues);
  }
};

let _currChart = null;

const doCreateChart = (el, options, getLabels, getValues) => {
  // if there is a current chart then destroy it first
  if (_currChart != null) _currChart.destroy();

  _currChart = new Chart(el, {
    type: "doughnut",
    data: {
      labels: getLabels(),
      datasets: [
        {
          data: getValues(),
          backgroundColor: function(context) {
            var index = context.dataIndex;
            if (index == 0) return getLineColour("TotalIncomeTax");
            if (index == 1) return getLineColour("TotalNI");
            if (index == 2) return getLineColour("TakeHome");
          }
        }
      ]
    },
    options
  });
};

const getLineColour = mode => {
  if (mode == "GrossInc") return "#B481D4";
  else if (mode == "TabableInc") return "#A2BBDE";
  else if (mode == "TotalTax") return "#231F7A";
  else if (mode == "TotalIncomeTax") return "#6EC79E";
  else if (mode == "TotalNI") return "#BBDE6F";
  else if (mode == "TakeHome") return "#D4B46A";
};
</script>

<style>
.row-header-dougnut {
  background-color: #cdd4d65e;
  /* border: 1px solid rgb(185, 197, 74); */
}

.row-data {
  background-color: #ffffeb98;
  border-bottom: 1px solid rgb(216, 216, 216);
}

.col1 {
  border-right: 1px solid lightgray;
}
.col2 {
  border-right: 1px solid white;
}
</style>